import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import TankHistoriesPageHeader from '@/components/pages/TankHistories/List/PageHeader'
import TankHistoriesTable from '@/components/pages/TankHistories/List/Table'
import routes from '@/constants/routes'

import { useTanks } from '../Tank/Tank.hooks'
import { useTankHistories } from './TankHistory.hooks'

const TankHistories = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { getTankDetail, getTankDetailResponse } = useTanks()
  const { getTankHistories, getTankHistoriesLoading, getTankHistoriesResponse, filterToQuery, page, pageSize } =
    useTankHistories()

  const totalItems = getTankHistoriesResponse?.meta.totalItems || 0

  useEffect(() => {
    if (id) {
      getTankDetail(Number(id))
      getTankHistories({ tankId: Number(id), page, limit: pageSize })
    }
  }, [getTankDetail, getTankHistories, id, page, pageSize])

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.tankHistories.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  return (
    <>
      <TankHistoriesPageHeader />
      <TankHistoriesTable
        tankId={Number(id)}
        {...{
          dataSource: getTankHistoriesResponse?.items,
          dataSourceDetail: getTankDetailResponse ? [getTankDetailResponse] : [],
          getTankHistoriesLoading,
          page,
          pageSize,
          totalItems,
          onChange: handleChangePage,
        }}
      />
    </>
  )
}

TankHistories.displayName = 'TankHistories'
export default TankHistories
